import { useMutation, useQueryClient } from 'react-query';
import { submitSolution } from 'api/services/competitions';

const useSubmitProblemSolution = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: async ({
      competitionId,
      problemId,
      answer,
      description,
    }) => submitSolution(competitionId, problemId, answer, description),
    onSuccess: async (response) => response,
    onError: async (error) => {
      console.log(error, 'Error in useSubmitProblemSolution');
      throw error; // Throw the error so it can be caught by the caller
    },
  });

  return {
    mutate: mutateAsync, // Expose mutateAsync instead of mutate
  };
};

export default useSubmitProblemSolution;
